export { useSkeletonContext } from '@fluentui/react-skeleton';
export type { SkeletonContextValue } from '@fluentui/react-skeleton';
